import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { catchError, map, of, take } from 'rxjs';
import { OptionStore } from '../stores/option.store';
import { OptionCode } from '@cardium/contracts';

export const clinicOptionGuard: CanActivateFn = () => {
  const store = inject(OptionStore);
  const code = OptionCode.ClinicOption.USERFORM;

  return store.rxGetOptionString(code).pipe(
    take(1),
    map(() => true),
    catchError(() => {
      return of(true); // Все равно пускаем, чтобы не блокировать вход
    }),
  );
};
